import {LINK_FRAGMENT} from '../link/query';

import {ACCORDION_LIST_FRAGMENT} from './accordion-container/query';
import {CALL_TO_ACTION_LINE_FRAGMENT} from './call-to-action-line-container/query';
import {COLOR_BLOCK_FRAGMENT} from './color-block/query';
import {INLINE_BANNER_FRAGMENT} from './inline-banner/query';

export const PORTABLE_TEXT_FRAGMENT = `//groq
	...,
	markDefs[] {
		...,
		${LINK_FRAGMENT}
	},
	${CALL_TO_ACTION_LINE_FRAGMENT},
	${COLOR_BLOCK_FRAGMENT},
	${ACCORDION_LIST_FRAGMENT},
	${INLINE_BANNER_FRAGMENT}
`;
